export default __webpack_public_path__ + "static/media/AllProductItems3.9266e729.png";